import { useEffect, useState } from "react";
import flotteService from "../../../../../services/flotteService";
import { getFieldConfig } from "./simulatorUtils";
import useFlotte from "../../hooks/useFlotte";

const useFlotteSimulator = (item) => {
  const { actions } = useFlotte();

  const [projections, setProjections] = useState(
    flotteService.initializeProjections(item),
  );
  const [externalValues, setExternalValues] = useState({});

  // Fonction pour mettre à jour une projection
  const updateProjection = async (index, field, value) => {
    const updatedProjections = [...projections];

    const projectionRef = { ...projections[index] };
    const oldValeurTheorique = projectionRef.valeur_theorique;
    projectionRef[field] = value;

    const updatedProjection = await flotteService.updateProjection({
      projection: projectionRef,
      item,
      modifiedField: field,
    });

    updatedProjections[index] = {
      ...updatedProjection,
    };
    setProjections(updatedProjections);

    // Propager la modification au state global pour que la modale conserve
    // les changements lors d'une réouverture sans rechargement complet de la page.
    actions.onUpdateProjection(item.id, index, updatedProjection);

    //cas particulier ou frais de RME est changé, dans ce cas on doit trigger updateCell
    if (
      field === "frais_remise_en_etat_devis" ||
      field === "frais_remise_en_etat_facture"
    ) {
      actions.onUpdateCell(
        item,
        "vo_prix_vente_facture",
        item.occasion.prix_de_vente_facture,
      );
    }

    //cas particulier si on change "valeur_theorique" et que la projection est de type "fin_reelle"
    if (field === "valeur_theorique" && projectionRef.type === "fin_reelle") {
      actions.onUpdateCell(item, "vo_valeur_theorique", value);
    }

    // Cas particulier : si la valeur_theorique a changé indirectement (via le recalcul d'un autre champ)
    // et que la projection est de type "fin_reelle", on doit aussi déclencher recalculer-vo
    if (
      field !== "valeur_theorique" && // Le champ modifié n'est PAS valeur_theorique
      projectionRef.type === "fin_reelle" && // La projection est de type fin_reelle
      updatedProjection.valeur_theorique !== undefined && // La réponse contient une valeur_theorique
      updatedProjection.valeur_theorique !== oldValeurTheorique // La valeur a changé
    ) {
      console.log(
        `Valeur théorique modifiée indirectement de ${oldValeurTheorique} à ${updatedProjection.valeur_theorique} suite à la modification de ${field}`,
      );
      actions.onUpdateCell(
        item,
        "vo_valeur_theorique",
        updatedProjection.valeur_theorique,
      );
    }
  };

  // Édition d'une cellule du sous-tableau RME (Fin réelle).
  // Passe par la route dédiée /renseigner-frais-fin-reelle au lieu de /recalculer.
  const updateRmeField = async (index, field, value) => {
    const updatedProjections = [...projections];
    const projectionRef = { ...projections[index], [field]: value };

    const updatedProjection = await flotteService.renseignerFraisFinReelle({
      projection: projectionRef,
      item,
    });

    updatedProjections[index] = { ...updatedProjection };
    setProjections(updatedProjections);

    actions.onUpdateProjection(item.id, index, updatedProjection);

    // Cohérence VO : un changement de frais_remise_en_etat_devis|facture
    // impacte le prix de vente facturé VO (comportement existant de
    // updateProjection — répliqué ici pour le nouveau flux).
    if (
      field === "frais_remise_en_etat_devis" ||
      field === "frais_remise_en_etat_facture"
    ) {
      actions.onUpdateCell(
        item,
        "vo_prix_vente_facture",
        item.occasion.prix_de_vente_facture,
      );
    }
  };

  const getSimulatorExternalValues = async () => {
    const response = await flotteService.getSimuationExternalValues(item);
    setExternalValues(response);
  };

  useEffect(() => {
    getSimulatorExternalValues();
  }, []);

  // Réinitialiser les projections quand l'item change
  useEffect(() => {
    setProjections(flotteService.initializeProjections(item));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item.id]);

  return {
    projections,
    externalValues,
    updateProjection,
    updateRmeField,
    getFieldConfig,
  };
};

export default useFlotteSimulator;
